import * as React from "react";
const BlueInfoSvg = (props) => (
  <svg
    width={28}
    height={28}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      width={24}
      height={24}
      rx={12}
      transform="matrix(1 0 0 -1 2 26)"
      fill="#D1E9FF"
    />
    <rect
      width={24}
      height={24}
      rx={12}
      transform="matrix(1 0 0 -1 2 26)"
      stroke="#EFF8FF"
      strokeWidth={4}
    />
    <g clipPath="url(#a)">
      <path
        d="M14 16v-2m0-2h.005M19 14a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
        stroke="#1570EF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M8 20h12V8H8z" />
      </clipPath>
    </defs>
  </svg>
);
export default BlueInfoSvg;
